import type { BodyLoginLoginAccessToken } from "@common/client"
import { LoginService } from "@common/client"
import type { UseQueryOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { featureFlagsKey } from "./feature-flags"
import { currentUserKey } from "./users"
import { makeAxiosMutation, unwrap } from "./utils"

export const sessionFreshnessKey = ["sessionFreshness"] as const

export interface SessionExpiry {
  expiresAt: number
}

export const sessionFreshnessQuery: UseQueryOptions<SessionExpiry> = {
  queryKey: sessionFreshnessKey,
  queryFn: async () => {
    const sentAt = Date.now()
    const { remaining_seconds } =
      await LoginService.getSessionFreshness().then(unwrap)
    return { expiresAt: sentAt + remaining_seconds * 1000 }
  },
}

export const useLogoutMutation = makeAxiosMutation({
  serviceCall: LoginService.logout,
  invalidates: () => [currentUserKey],
})

export const useLoginMutation = makeAxiosMutation({
  invalidates: () => [currentUserKey, sessionFreshnessKey, featureFlagsKey],
  serviceCall: async (input: BodyLoginLoginAccessToken) => {
    const response = await LoginService.loginAccessToken({
      bodyLoginLoginAccessToken: input,
    })
    if (!(response instanceof AxiosError)) {
      localStorage.setItem("access_token", response.data.access_token)
    }
    return response
  },
})
